import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-anchor', 'top', 'Kerige lehe ülaossa');
Labels.set('ui-anchor', 'bottom', 'Kerige lehe allossa');
Labels.set('ui-anchor', 'left', 'Kerige vasakule');
Labels.set('ui-anchor', 'right', 'Kerige paremale');
